import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/inbox/dismiss/bulk']['PUT'];

type Input = ThisApi['body'];

const bulkDismissInboxItems = async ({ inboxItemIds }: Input): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.put<ThisApi['response']>('/inbox/dismiss/bulk', {
    inboxItemIds,
  });
  return response.data;
};

export default bulkDismissInboxItems;
